// const SOCKETS_URL = "http://localhost:3001";
const SOCKETS_URL = "https://server.lbproject.womi.ma";
export default SOCKETS_URL;
